export default "__VITE_ASSET__szOD5TTH__"